import IntegrationsPage from "@/components/marketing/products/integrations/IntegrationsPage"

type Props = {}

const index = (_props: Props) => {
  return <IntegrationsPage />
}

export default index
